import axiosInstance from '../../utils/axiosInstance';

const SALARY_API = 'api/hr/salary-api.php';

// Get paginated active salaries (one row per employee - list/dashboard view)
export const getActiveSalaries = async (page = 1, limit = 10) => {
    try {
        const response = await axiosInstance.get(`${SALARY_API}?page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching active salaries:', error);
        throw error;
    }
};

// Get full salary revision history (newest first) for one employee
export const getSalaryHistory = async (employeeId) => {
    try {
        const response = await axiosInstance.get(`${SALARY_API}?employee_id=${employeeId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching salary history:', error);
        throw error;
    }
};

// Get the current active salary for one employee (used to prefill increment/adjustment forms)
export const getActiveSalaryForEmployee = async (employeeId) => {
    try {
        const response = await axiosInstance.get(`${SALARY_API}?employee_id=${employeeId}&active=true`);
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            return null;
        }
        console.error('Error fetching active salary for employee:', error);
        throw error;
    }
};

// Create an INITIAL, INCREMENT, or ADJUSTMENT salary revision
export const createSalaryRevision = async (payload) => {
    try {
        const response = await axiosInstance.post(SALARY_API, payload);
        return response.data;
    } catch (error) {
        console.error('Error creating salary revision:', error);
        throw error;
    }
};

const getTemplateFilename = (response, fallback) => {
    const contentDisposition = response?.headers?.['content-disposition'];
    if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) return match[1];
    }
    return fallback;
};

// Download the initial salary import template
export const downloadSalaryTemplate = async () => {
    const response = await axiosInstance.get(`${SALARY_API}?download-salary-template=true`, {
        responseType: 'blob',
    });
    return {
        blob: response.data,
        filename: getTemplateFilename(response, 'Salary_Template.xlsx'),
        contentType: response.headers['content-type'],
    };
};

// Download the increment import template
export const downloadIncrementTemplate = async () => {
    const response = await axiosInstance.get(`${SALARY_API}?download-increments-template=true`, {
        responseType: 'blob',
    });
    return {
        blob: response.data,
        filename: getTemplateFilename(response, 'Increment_Template.xlsx'),
        contentType: response.headers['content-type'],
    };
};

// Import salaries (import-type = 'salaries') or increments (import-type = 'increments')
export const importSalaryExcel = async (importType, formData) => {
    formData.append('import-type', importType);
    try {
        const response = await axiosInstance.post(SALARY_API, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        console.error('Error importing salary excel:', error);
        throw error;
    }
};

